import requests from '../requests';

const email = {
  sendSupportMail: (form) => requests.post('/email/sendsupportmail', form),
};

export default email;
